const guidebookLoaded = state => state.guidebook.initial.root !== undefined;

export default guidebookLoaded;
